/* eslint-disable */
// CSS
import "../sass/portfolio.sass";
// JS
import { gsap } from "gsap";

//網頁資料下載完成
document.addEventListener('DOMContentLoaded', function() {
  // LOADING
  let loading = document.querySelector('div.loading');
  setTimeout(function(){ gsap.to(loading, { opacity: 0, ease: "power3.inOut", overwrite: true, duration: 2 });},1500);

// --- DOM 參考 ---
  var menuIcon = document.querySelector(".menu_icon");
  var menuBtns = document.querySelector(".menu_btns");
  var closeIcon = document.querySelector(".menu_close_icon");

  var workTitle = document.querySelector(".work_title");
  var workTitleChi = document.querySelector(".work_title_chi");
  var workDatas = document.querySelector(".work_datas"); // 作品容器

  // --- 分類標題對照（僅控制標題顯示）---
  var categoryMap = {
    "": { en: "ALL WORKS", chi: "_ 全部作品" },
    "graphic_design": { en: "GRAPHIC DESIGN", chi: "_ 平面設計" },
    "production_3d": { en: "3D PRODUCTION", chi: "_ 3D 製作" },
    "web_design": { en: "WEB DESIGN", chi: "_ 網頁設計" },
    "webxr": { en: "WEBXR", chi: "_ WebXR" },
    "ai_service": { en: "GENERATIVE AI", chi: "_ 生成式 AI" },
    "award": { en: "AWARD", chi: "_ 獲獎作品" }
  };

  // --- 狀態 ---
  var works = []; // 從 portfolio.json 載入的作品

  // --- Menu 開關 ---
  if (menuIcon && menuBtns) {
    menuIcon.addEventListener("click", function () {
      menuBtns.style.display = "flex";
    });
  }
  if (closeIcon && menuBtns) {
    closeIcon.addEventListener("click", function () {
      menuBtns.style.display = "none";
    });
  }

  // 點擊 menu_btn → 改變 hash（ALL WORKS 會清空 hash 並手動更新）
  var menuButtons = document.querySelectorAll(".menu_btn");
  for (var i = 0; i < menuButtons.length; i++) {
    menuButtons[i].addEventListener("click", function () {
      var text = this.textContent ? this.textContent.trim() : "";
      if (text === "ALL WORKS") {
        history.pushState("", document.title, window.location.pathname + window.location.search);
        updateView(); // 清 hash 不會觸發 hashchange，手動更新
      } else if (this.id) {
        location.hash = this.id;
      }
      if (menuBtns) menuBtns.style.display = "none";
      setActiveMenu(); // 更新選單高亮
    });
  }

  // --- 讀取作品 JSON ---
  function loadWorks() {
    fetch("json/portfolio.json")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // data 可能是陣列（你的格式），也可能是 {works:[...]}
        works = Array.isArray(data) ? data : (data.works || []);
        updateView(); // 初始渲染
      })
      .catch(function (err) {
        console.error("載入 portfolio.json 失敗: ", err);
        if (workDatas) {
          workDatas.innerHTML = "<p>資料載入失敗，稍後再試。</p>";
        }
      });
  }

  // --- 更新整體畫面（標題 + 作品列表）---
  function updateView() {
    var currentHash = location.hash.replace("#", "");
    updateTitles(currentHash);
    renderFilteredWorks(currentHash);
    setActiveMenu();
  }

  // --- 更新標題 ---
  function updateTitles(hashKey) {
    var data = categoryMap[hashKey] || categoryMap[""];
    if (workTitle) {
      workTitle.innerHTML = '<img src="images/title_icon.svg" />' + data.en;
    }
    if (workTitleChi) {
      workTitleChi.textContent = data.chi;
    }
  }

  // --- 渲染符合標籤的作品到 .work_datas ---
  function renderFilteredWorks(hashKey) {
    if (!workDatas) return;
    workDatas.innerHTML = "";

    var list = [];
    if (!hashKey) {
      list = works.slice(0); // 全部
    } else {
      list = works.filter(function (item) {
        return Array.isArray(item.tags) && item.tags.indexOf(hashKey) !== -1;
      });
    }

    if (!list.length) {
      workDatas.innerHTML = "<p>暫無此分類的作品</p>";
      return;
    }

    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var div = document.createElement("div");
      div.className = "work_data " + (item.className || "w100");

      // link（有值才顯示）
      var linkHtml = "";
      if (item.link && String(item.link).trim() !== "") {
        linkHtml =
          '<p class="work_link">網址: ' +
          '<a class="web_link" target="_blank" href="' + item.link + '">' +
          item.link +
          "</a></p>";
      }

      
      

      // --- 媒體區塊（新增）---
      let mediaHtml = "";
      if (item.video) {
        // 取出 YouTube ID（支援 watch?v= / youtu.be / embed）
        const match = item.video.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
        const videoId = match ? match[1] : "";
        if (videoId) {
          const isShorts = item.video.includes("/shorts/");
          mediaHtml = `
            <div class="video_wrapper ${isShorts ? "short" : ""}">
              <iframe
                src="https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="width:100%; height:100%; background:#000;">
              </iframe>
            </div>
          `;
        }
      } else if (item.image) {
        mediaHtml = `<img class="work_image" src="${item.image}" alt="${item.title || ""}"/>`;
      }

      // --- 原本 html 改這樣 ---
      var html =
        mediaHtml +
        '<p class="work_subtitle_chi">' + (item.title || "") + "</p>" +
        '<p class="work_subtitle_en">' + (item.title_en || "") + "</p>" +
        '<p class="work_text_chi">' + (item.description || "") + "</p>" +
        '<p class="work_text_en">' + (item.description_en || "") + "</p>" +
        linkHtml;





      div.innerHTML = html;
      workDatas.appendChild(div);
    }
  }

  // --- 選單高亮（可選）---
  function setActiveMenu() {
    var currentHash = location.hash.replace("#", "");
    var btns = document.querySelectorAll(".menu_btn");
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var text = btn.textContent ? btn.textContent.trim() : "";
      var id = btn.id || "";
      var isAll = text === "ALL WORKS" && !currentHash;
      var isMatch = id && id === currentHash;
      if (isAll || isMatch) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    }
  }

  // --- 監聽 hash 改變 ---
  window.addEventListener("hashchange", updateView);

  // --- 啟動 ---
  loadWorks();
  setActiveMenu();




});